import type { MilkEntity } from './entity/milkEntity';
import type { MilkIRepository } from './entity/milkIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * ミルクドメインサービス
 */
export class MilkDomainService extends DomainServiceBase {
  private milkRepository!: MilkIRepository;

  /**
   * Injection
   * @param milkRepository milkRepository
   */
  public inject(
    milkRepository: MilkIRepository,
  ) {
    this.milkRepository = milkRepository;
  }

  /**
   * ミルク取得
   * @param token トークン
   * @returns 一覧
   */
  async getMilkList(token: string | null) {
    const result = await this.milkRepository.getList(token);
    const { nextToken } = result;
    const items = result.items.map((v: MilkEntity) => v.toJson());
    return {
      /** 次のトークン */
      nextToken,
      /** アイテムリスト */
      items,
    };
  }

  /**
   * 指定日のミルクリスト取得
   * @param date 日付
   * @returns リスト
   */
  async getMilkListWithDate(date: string) {
    const result = await this.milkRepository.getAllListWithKey(date);
    const items = result.map((v: MilkEntity) => v.toJson());
    return items;
  }

  /**
   * ミルク作成
   * @param entity 入力
   * @returns 結果
   */
  async createMilk(
    entity: MilkEntity,
  ) {
    const result = await this.milkRepository.create(entity);
    return result;
  }

  /**
   * ミルク更新
   * @param entity 入力
   * @returns 結果
   */
  async updateMilk(
    entity: MilkEntity,
  ) {
    const result = await this.milkRepository.update(entity);
    return result;
  }

  /**
   * ミルク削除
   * @param entity 入力
   * @returns 結果
   */
  async deleteMilk(
    entity: MilkEntity,
  ) {
    const result = await this.milkRepository.delete(entity);
    return result;
  }
}
